import { IContactDetails } from "../types/types";
import { callApi } from "./api.service";

export const GetContactDetails = async (
    data: IContactDetails
) => {
    const endpoints = "/api/contact/send-email";
    return await callApi(endpoints, "POST", false, undefined, data);
}

